// Import model
import { UpdateCustomerReviewRequest } from '../models/UpdateCustomerReviewRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdateCustomerReviewRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdateCustomerReviewRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdateCustomerReviewRequest instance
   */
  static deserialize(json: string): UpdateCustomerReviewRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdateCustomerReviewRequest instance
   */
  static fromObject(obj: any): UpdateCustomerReviewRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdateCustomerReviewRequest');
    }


    const instance: UpdateCustomerReviewRequest = {
      provider: obj['provider'] as string | undefined,
      description: obj['description'] as string | undefined,
      leadId: obj['leadId'] as string | undefined,
      projectExternalId: obj['projectExternalId'] as string | undefined,
      role: obj['role'] as string | undefined,
      tags: obj['tags'] ? (obj['tags'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      isActive: obj['isActive'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdateCustomerReviewRequest instances
   */
  static deserializeArray(json: string): UpdateCustomerReviewRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdateCustomerReviewRequest instance to a JSON string
   */
  static serialize(instance: UpdateCustomerReviewRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdateCustomerReviewRequest instance to a plain object
   */
  static toObject(instance: UpdateCustomerReviewRequest): any {
    return {
      'provider': instance.provider,
      'description': instance.description,
      'leadId': instance.leadId,
      'projectExternalId': instance.projectExternalId,
      'role': instance.role,
      'tags': instance.tags?.map((item: any) =>
        item
      ),
      'isActive': instance.isActive,
    };
  }

  /**
   * Serializes an array of UpdateCustomerReviewRequest instances to a JSON string
   */
  static serializeArray(instances: UpdateCustomerReviewRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
